import { TruncatePipe } from '@aipb/shared/ui/pipes';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'fr-personal-content-button',
  standalone: true,
  imports: [RouterLink, MatButtonModule, MatIconModule, TruncatePipe],
  templateUrl: './personal-content-button.component.html',
  styleUrls: ['./personal-content-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonalContentButtonComponent {
  @Input() username: string;
  @Input() isLoggedIn: boolean;
  @Input() hasPersonalContent: boolean;
  @Input() isPersonalContentEnabled: boolean;

  id = 'all_toolbar_btn_open-personal-content';
}
